import { api } from 'api'
import moment from 'moment/moment'
import { useMutation } from '@tanstack/react-query'
import { DATE_FORMAT } from 'shared/utils/dateFormatting'
import { toaster } from 'uikit/Toaster'

const dateFormat = 'YYYY-MM-DD'

export const useSendParityRegistry = () => {
  return useMutation({
    mutationFn: ({ date }: any) => {
      const momentDate = moment(date, DATE_FORMAT)

      return api.payments.sendParityRegistry({
        from: date ? momentDate.format(dateFormat) : undefined,
        to: date ? momentDate.add(1, 'd').format(dateFormat) : undefined,
      })
    },
    onSuccess: () => {
      toaster.create({
        type: 'success',
        title: 'Запрос на формирование отчета отправлен успешно',
      })
    },
    onError: (err) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при отправке реестров',
        description: err.message,
      })
    },
  })
}
